<script>
export default {
	name: 'PlanYourTripTiles',
	inheritAttrs: false,
};
</script>

<script setup>
import { useGlobalAEMState } from '~/logic/aem/global-aem-state.js';
import PlanYourTripCard from '~/components/PlanYourTripCard.vue';

const props = defineProps({
	isHideInDesktop: { type: Boolean, default: false },
	isHideInMobile: { type: Boolean, default: false },
	tilesMultiList: { type: Array, default: () => [] },
	componentIdAA: { type: String, default: '' },
});

const cardSize = computed(() => { return props.tilesMultiList.length > 3 ? '>md:w-3/12' : '>md:w-1/3'; } );
const { isEditorMode } = useGlobalAEMState();

const siteName = window.siteName;

</script>

 

<template>
<div
	v-if="props.tilesMultiList.length"
	class="PlanYourTripTiles"
	:class="{
		'>md:hidden': isHideInDesktop,
		'hidden >md:block': isHideInMobile,
	}"
	:data-use-theme="siteName"
>
	<div class="flex flex-col >md:flex-row justify-center gap-2 >md:gap-6 w-full">
		<PlanYourTripCard
			v-for="tile in props.tilesMultiList"
			:key="`${tile.title}`"
			:keyVisualSrc="`${tile.keyVisualSrc}`"
			:keyVisualAlignment="`${tile.keyVisualAlignment}`"
			:keyVisualAlt="`${tile.keyVisualAlt}`"
			:gradientValue="`${tile.gradientValue}`"
			:gradientOpacity="`${tile.gradientOpacity}`"
			:bgSrc="`${tile.bgSrc}`"
			:bgAlt="`${tile.bgAlt}`"
			:title="`${tile.title}`"
			:url="`${tile.url}`"
			:openInNewTab="tile.openInNewTab"
			:cardSize="cardSize"
			:componentIdAA="props.componentIdAA"
		/>
	</div>
</div>

<div v-else-if="isEditorMode && isHideInDesktop" class="generic-container py-10 text-center">
	<p>Hidden in: <span v-if="isHideInDesktop">Desktop</span> <span v-if="isHideInMobile">, Mobile</span></p>
</div>

</template>



<style scoped lang="scss">
@use 'sass:color';
@use '~/styles/partials/_var.scss';

.PlanYourTripTiles[data-use-theme="firefly"] {
	:deep(.inner-wrapper) {
		background-color: var(--secondary-firefly-orange-extralight);
		@apply rounded-3xl;
		@apply rounded-br-none;
	}
	:deep(.bg-element-wrapper) {
		display: none;
	}
}
</style>
